import React, { useState } from "react";
import SEO from "../components/SEO";
import DropMenu from "../components/DropMenu";
import HeroSection from "../components/HeroSection";
import ServicesSection from "../components/ServicesSection";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import About from "../components/About";

const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Shift IT",
  url: "https://shift-it.io/",
  description:
    "Strategic IT for small professional services teams. Reduce overhead, tighten systems, and help knowledge workers deliver more through reliable Microsoft 365, security, and automation.",
  areaServed: "Atlanta, GA",
};

const Home = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <SEO
        title="Shift IT | Strategic IT for Professional Services Teams"
        description="Strategic IT services for small professional services teams in Atlanta. Reduce overhead, tighten systems, and keep knowledge workers moving with reliable Microsoft 365, security, and automation."
        canonical="https://shift-it.io/"
        jsonLd={organizationJsonLd}
      />

      <DropMenu isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />

      <HeroSection />
      <About />
      <ServicesSection />

      <Footer />
    </>
  );
};

export default Home;
